module.exports = __webpack_public_path__ + "static/media/kitchen2.1af9d952.png";